/*
 * @Description:
 * @Author: 赵大壮
 * @Date: 2021-12-07 12:03:10
 * @LastEditTime: 2022-12-05 12:37:25
 * @LastEditors: 赵大壮
 */

import store from "@/store";

class DZModelSystemConfig {
  arr_menuList = [
    // {
    //     id: 1,
    //     icon: "iconfont icon-cebianlanicon_shujuzhongxin_weixuanzhong",
    //     index: "/data",
    //     title: "数据中心",
    // },
    {
      id: 2,
      icon: "el-icon-s-marketing",
      index: "/assess",
      title: "测评管理",
    },
    {
      id: 3,
      icon: "el-icon-s-grid",
      index: "/pre-work",
      title: "岗前测评",
    },
    {
      id: 4,
      icon: "el-icon-office-building",
      index: "/company",
      title: "公司管理",
    },
    {
      id: 5,
      icon: "el-icon-s-claim",
      index: "/report",
      title: "报告管理",
      subs: [
        {
          id: 501,
          index: "/report/list",
          title: "测评结果",
        },
        {
          id: 502,
          index: "/report/assessinfo",
          title: "测评记录",
        },
      ],
    },
    {
      id: 6,
      icon: "el-icon-s-management",
      index: "/article",
      title: "文章管理",
      subs: [
        {
          id: 601,
          index: "/article/type",
          title: "分类管理",
        },
        {
          id: 602,
          index: "/article/list",
          title: "内容管理",
        },
      ],
    },
    {
      id: 7,
      icon: "el-icon-s-platform",
      index: "/video",
      title: "视频管理",
      subs: [
        {
          id: 701,
          index: "/video/type",
          title: "分类管理",
        },
        {
          id: 702,
          index: "/video",
          title: "内容管理",
        },
      ],
    },
    {
      id: 8,
      icon: "el-icon-s-order",
      index: "/investigate",
      title: "问卷管理",
      subs: [
        {
          id: 801,
          index: "/investigate/list",
          title: "调查问卷",
        },
        {
          id: 802,
          index: "/base/template",
          title: "基本信息",
        },
        {
          id: 803,
          index: "/question/template",
          title: "问卷问题",
        },
        {
          id: 804,
          index: "/investigate/req",
          title: "调查结果",
        },
        {
          id: 805,
          index: "/investigate/reqList",
          title: "综合问卷记录",
        },
      ],
    },
    {
      id: 9,
      icon: "el-icon-picture",
      index: "/banner",
      title: "banner管理",
      subs: [
        {
          id: 901,
          index: "/banner/list",
          title: "企业版",
        },
        {
          id: 902,
          index: "/banner/storelist",
          title: "个人版",
        },
      ],
    },
    {
      id: 10,
      icon: "el-icon-s-help",
      index: "/export",
      title: "咨询管理",
      subs: [
        {
          id: 1001,
          index: "/export/list",
          title: "咨询师列表",
        },
        {
          id: 1002,
          index: "/export/service",
          title: "预约记录",
        },
      ],
    },
    {
      id: 11,
      icon: "el-icon-message-solid",
      index: "/feedback",
      title: "意见反馈",
    },
    {
      id: 12,
      icon: "el-icon-s-goods",
      index: "/goods",
      title: "商城管理",
      subs: [
        {
          id: 1201,
          index: "/goods/list",
          title: "商品管理",
        },
        {
          id: 1202,
          index: "/store/user",
          title: "用户管理",
        },
        {
          id: 1203,
          index: "/store/order",
          title: "订单管理",
        },
        {
          id: 1204,
          index: "/store/userSubscribe",
          title: "个人预约记录",
        },
        {
          id: 1205,
          index: "/store/userAssess",
          title: "个人测评记录",
        },
        {
          id: 1206,
          index: "/store/occupation",
          title: "职业字典管理",
        },
      ],
    },
    {
      id: 13,
      icon: "el-icon-s-ticket",
      index: "/coupon",
      title: "优惠券管理",
    },
    {
      id: 14,
      icon: "el-icon-user-solid",
      index: "/user",
      title: "用户管理",
      subs: [
        {
          id: 1401,
          index: "/user/role",
          title: "角色列表",
        },
        {
          id: 1402,
          index: "/user/admin",
          title: "管理员列表",
        },
      ],
    },
    {
      id: 15,
      icon: "el-icon-s-tools",
      index: "/setting",
      title: "系统设置",
      subs: [
        {
          id: 1501,
          index: "/setting/list",
          title: "登录方式",
        },
      ],
    },
  ];

  constructor() {}
}

export default DZModelSystemConfig;
